export default function readSpEnv(name) {
	return (
		typeof window !== 'undefined' &&
		window.SP &&
		window.SP.env &&
		window.SP.env[name]
	);
}
